var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.937499 6.5627H12.0562L8.65312 2.4752C8.49399 2.28374 8.41744 2.03692 8.44029 1.78902C8.46315 1.54112 8.58355 1.31245 8.775 1.15332C8.96645 0.994193 9.21328 0.917634 9.46118 0.94049C9.70908 0.963346 9.93775 1.08374 10.0969 1.2752L14.7844 6.9002C14.8159 6.94494 14.8441 6.99194 14.8688 7.04082C14.8688 7.0877 14.8687 7.11582 14.9344 7.1627C14.9769 7.27019 14.9991 7.38461 15 7.5002C14.9991 7.61578 14.9769 7.7302 14.9344 7.8377C14.9344 7.88457 14.9344 7.9127 14.8688 7.95957C14.8441 8.00845 14.8159 8.05546 14.7844 8.1002L10.0969 13.7252C10.0087 13.831 9.89835 13.9161 9.77358 13.9745C9.64882 14.0328 9.51273 14.0629 9.375 14.0627C9.15595 14.0631 8.94367 13.9868 8.775 13.8471C8.68007 13.7684 8.6016 13.6717 8.54408 13.5626C8.48656 13.4536 8.45113 13.3342 8.43981 13.2114C8.42849 13.0886 8.4415 12.9648 8.47811 12.8471C8.51471 12.7293 8.57418 12.6199 8.65312 12.5252L12.0562 8.4377H0.937499C0.688859 8.4377 0.450401 8.33893 0.274586 8.16311C0.0987704 7.98729 -9.53674e-07 7.74884 -9.53674e-07 7.5002C-9.53674e-07 7.25156 0.0987704 7.0131 0.274586 6.83728C0.450401 6.66147 0.688859 6.5627 0.937499 6.5627Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitearrow);
export default __webpack_public_path__ + "static/media/whitearrow.e284fba32ac72fdb27a6c12adc0afb08.svg";
export { ForwardRef as ReactComponent };